var React = require('react');

function Growth (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",null,React.createElement("g",null,React.createElement("g",{"transform":"translate(-1029 -4158) translate(1030 4155) translate(0 3)"},[React.createElement("path",{"fill":"#C3CAD2","d":"M9.705 8.44c2.672 0 4.329.811 4.97 2.435L12.5 13.142l-2.1-2.188-4.702 4.898H4.431v-3.193c0-2.813 1.758-4.22 5.274-4.22z","key":0}),React.createElement("circle",{"cx":"9.705","cy":"2.637","r":"2.637","fill":"#C3CAD2","key":1}),React.createElement("path",{"stroke":"#C3CAD2","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.227","d":"M0 15.852L5.698 15.852 10.4 10.954 12.5 13.142 20.255 5.064M20.466 5.064L20.466 8.862M20.255 5.064L16.457 5.064","key":2})])))));
}

Growth.defaultProps = {"width":"23","height":"17","viewBox":"0 0 23 17"};

module.exports = Growth;

Growth.default = Growth;
